module.exports = " <li style=position:relative _v-564dc99e=\"\"> <a @mousedown.prevent=handleClick style=cursor:pointer _v-564dc99e=\"\"> <span v-el:v=\"\" _v-564dc99e=\"\"><slot _v-564dc99e=\"\"></slot></span> <span class=\"glyphicon glyphicon-ok check-mark\" v-show=chosen _v-564dc99e=\"\"></span> </a> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/template-rewriter.js?id=_v-564dc99e!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/vue-strap/Option.vue
// module id = 275
// module chunks = 0